import { render, staticRenderFns } from "./LeaveCollection.vue?vue&type=template&id=344af338&scoped=true&"
import script from "./LeaveCollection.vue?vue&type=script&lang=js&"
export * from "./LeaveCollection.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCollection.vue?vue&type=style&index=0&id=344af338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344af338",
  null
  
)

export default component.exports